export const cpfPattern = ['999.999.999-99'];

export const unmaskCpf = ['99999999999'];

export const cnpjPattern = ['99.999.999/9999-99'];

export const unmaskCNPJ = ['99999999999999'];

export const unmaskCPFandCNPJ = ['99999999999', '99999999999999'];

export const cepPattern = ['99.999-999'];

export const unmaskCep = ['99999999'];

export const cnaePattern = ['99.99-9-99'];

export const unmaskCnae = ['9999999'];

export const phonePattern = ['(99) 99999-9999'];

export const unmaskPhonePattern = ['99999999999'];

export const birthdayPattern = ['99/99/9999'];

export const unmaskCepPattern = ['99999999'];
